module.exports = __webpack_public_path__ + "img/small-11.8f473d9f.jpg";